/**
 * Shared analytics tracking utilities.
 * Loaded before page-specific scripts via <script> tag in base.html.
 * All exports are assigned to window.* globals.
 */

const trackFeature = (feature) => {
  window.umami?.track('feature-used', { feature });
};

const trackOnboardingStep = (product, step) => {
  window.umami?.track(`onboarding-${product}-step`, { step });
};

window.trackFeature = trackFeature;
window.trackOnboardingStep = trackOnboardingStep;
